import { useState } from "react";
import {
  Container,
  Nav,
  Navbar as ReactBootstrapNavbar,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "./Navbar.scss";

const navigationLinks = [
  // { label: "Home", to: "/" },
  // { label: "About-FROI", to: "/froi-about" },
  // { label: "FROI’s Model", to: "/froi-model" },
  // { label: "FROI’s Accreditation", to: "/froi-accreditation" },
  // { label: "FROI’s Global Index", to: "/froi-global-index" },
  // { label: "FROI’s TALENT SANDBOX™", to: "/froi-talent-sandbox" },
  // { label: "FROI’s Center", to: "/froi-center" },
  // { label: "Global Offices ", to: "/contact" },
  { label: "Home", to: "/" },
  { label: "About", to: "/froi-about" },
  { label: "Accreditation", to: "/froi-accreditation" },
  { label: "Certification™", to: "/froi-certification" },
  { label: "Global Index", to: "/froi-global-index" },
  { label: "FROI’s Model", to: "/froi-model" },
  // { label: "FROI’s Center", to: "/froi-center" },
  //{ label: "Global Offices ", to: "/contact" },
];

function Navbar() {
  const [expanded, setExpanded] = useState(false);

  const closeMenu = () => {
    setExpanded(false);
  };

  return (
    //one line navbar
    <ReactBootstrapNavbar
      expand="lg"
      sticky="top"
      expanded={expanded}
      onToggle={(isExpanded) => setExpanded(isExpanded)}
      className="froi-navbar"
    >
      <div className="froi-navbar__container">
        <ReactBootstrapNavbar.Brand
          as={NavLink}
          to="/"
          end
          className="froi-navbar__brand"
          // onClick={closeMenu}
        >
          <img
            src="/images/logo.png"
            alt="FROI Logo"
            className="froi-navbar__logo"
          />
        </ReactBootstrapNavbar.Brand>

        <ReactBootstrapNavbar.Toggle
          aria-controls="froi-navbar"
          aria-label="Toggle navigation"
          className="froi-navbar__toggle"
          //onClick={() => setExpanded((prev) => !prev)}
        />

        <ReactBootstrapNavbar.Collapse id="froi-navbar">
          <Nav className="froi-navbar__nav">
            {navigationLinks.map((link) => (
              <Nav.Link
                as={NavLink}
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `froi-navbar__link ${isActive ? "active" : ""}`
                }
                onClick={closeMenu}
              >
                {link.label}
              </Nav.Link>
            ))}
          </Nav>

          <NavLink
            to="/contact"
            className="froi-navbar__button"
            onClick={closeMenu}
          >
            Get in touch
          </NavLink>
        </ReactBootstrapNavbar.Collapse>
      </div>
    </ReactBootstrapNavbar>
    // <ReactBootstrapNavbar
    //   expand="lg"
    //   sticky="top"
    //   expanded={expanded}
    //   onToggle={(isExpanded) => setExpanded(isExpanded)}
    //   className="froi-navbar"
    // >
    //   <div className="froi-navbar__container">
    //     <ReactBootstrapNavbar.Brand
    //       as={NavLink}
    //       to="/"
    //       end
    //       className="froi-navbar__brand"
    //       onClick={closeMenu}
    //     >
    //       <img src="./images/logo.png" alt="FROI_logo" width={140} />
    //       {/* <FroiLogo /> */}
    //     </ReactBootstrapNavbar.Brand>

    //     <ReactBootstrapNavbar.Toggle
    //       aria-controls="froi-navbar"
    //       aria-label="Toggle navigation"
    //       className="froi-navbar__toggle"
    //     />

    //     <ReactBootstrapNavbar.Collapse id="froi-navbar">
    //       <Nav className="froi-navbar__nav">
    //         {navigationLinks.map((link) => (
    //           <Nav.Link
    //             as={NavLink}
    //             key={link.to}
    //             to={link.to}
    //             end={link.to === "/"}
    //             className={({ isActive }) =>
    //               `froi-navbar__link ${isActive ? "active" : ""}`
    //             }
    //             onClick={closeMenu}
    //           >
    //             {link.label}
    //           </Nav.Link>
    //         ))}
    //       </Nav>
    //       <Nav className="froi-navbar__nav">
    //         {" "}
    //         <Nav.Link
    //           as={NavLink}
    //           to={"/contact"}
    //           className="froi-navbar__contact"
    //           onClick={closeMenu}
    //         >
    //           Contact Us
    //         </Nav.Link>
    //       </Nav>
    //     </ReactBootstrapNavbar.Collapse>
    //   </div>
    // </ReactBootstrapNavbar>
    /* <ReactBootstrapNavbar
  expand="lg"
  sticky="top"
  expanded={expanded}
  onToggle={(isExpanded) => setExpanded(isExpanded)}
  className="froi-navbar"
>
  <Container className="froi-navbar__container">
    
    {/* Logo Row */
    //   <div className="froi-navbar__top">
    //     <ReactBootstrapNavbar.Brand
    //       as={NavLink}
    //       to="/"
    //       end
    //       className="froi-navbar__brand"
    //       onClick={closeMenu}
    //     >
    //       <img
    //         src="/images/logo.png"
    //         alt="FROI Logo"
    //         className="froi-navbar__logo"
    //         width={160}
    //       />
    //     </ReactBootstrapNavbar.Brand>

    //     <ReactBootstrapNavbar.Toggle
    //       aria-controls="froi-navbar"
    //       aria-label="Toggle navigation"
    //       className="froi-navbar__toggle"
    //     />
    //   </div>

    //   {/* Navigation Row */}
    //   <ReactBootstrapNavbar.Collapse id="froi-navbar">
    //     <Nav className="froi-navbar__nav">
    //       {navigationLinks.map((link) => (
    //         <Nav.Link
    //           as={NavLink}
    //           key={link.to}
    //           to={link.to}
    //           end={link.to === "/"}
    //           className={({ isActive }) =>
    //             `froi-navbar__link ${isActive ? "active" : ""}`
    //           }
    //           onClick={closeMenu}
    //         >
    //           {link.label}
    //         </Nav.Link>
    //       ))}
    //     </Nav>
    //   </ReactBootstrapNavbar.Collapse>

    // </Container>
    // </ReactBootstrapNavbar> */}
  );
}

export default Navbar;
